module.exports = __webpack_public_path__ + "img/home-ico-black.9eb59c0a.png";